import LeadMagnetPage from '../components/LeadMagnetPage'

export default function RecruiterLeadMagnet() {
  return <LeadMagnetPage type="recruiter" />
}
